module.exports = (parcelRequire.load("50JJJ")).then(() => parcelRequire('n7Qh0'));